import { render, staticRenderFns } from "./createDivision.vue?vue&type=template&id=1f766a94&scoped=true"
import script from "./createDivision.vue?vue&type=script&lang=js"
export * from "./createDivision.vue?vue&type=script&lang=js"
import style0 from "./createDivision.vue?vue&type=style&index=0&id=1f766a94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f766a94",
  null
  
)

export default component.exports